import { Link } from "react-router-dom"

import { motion } from "framer-motion"
import { PiX } from "react-icons/pi"

import { isIphone } from "@/utils/device"

interface HeaderCancelProps {
  to: string
}

const HeaderCancel = ({ to }: HeaderCancelProps) => {
  return (
    <motion.div className={`flex flex-row pb-4 px-[1.12rem] ${isIphone ? 'pt-1' : 'pt-3'}`}
      whileTap={{ scale: 0.98 }}
    >
      <Link to={to} className="flex items-center justify-center rounded-full bg-zinc-100 p-2">
        <PiX className="w-5 h-5" />
      </Link>
    </motion.div>
  )
}

export default HeaderCancel